export default "__VITE_ASSET__Cyoj0gg4__"